module.exports = __webpack_public_path__ + "img/partner3.30ee7f73.svg";